import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthorizationService } from '../components/authorization/authorization.service';
import { WindowRef } from './window';
@Injectable({ providedIn: 'root' })

export class AuthGuardService  {
  cookieToken = 'UNKNOWN';
    currentCountry: string;
    constructor(private _router: Router, private authService: AuthorizationService) {
    }
    isAuth = '';
    isAdminAuth='';

    canActivate(
      route: ActivatedRouteSnapshot,
    ): Observable<boolean>|Promise<boolean>|boolean {

      this.isAuth = sessionStorage.getItem('auth');
      if(this.isAuth !== null && this.isAuth === 'yes') {
        return true;
      } else {
        this._router.navigate(['/home/acm']);
        return false;
      }
    }
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuthGuardService implements CanActivate {

  constructor(
    private router: Router,
    private auth: AuthorizationService,
    private windowRef: WindowRef
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    console.log("admin canActivate called");
    const code = this.windowRef.nativeWindow?.mbfs?.code;
    const sessionState = this.windowRef.nativeWindow?.mbfs?.sessionState;
    // User already authenticated
    if (sessionStorage.getItem('username') !== null) {
      console.log('User found in session storage'+sessionStorage.getItem('username'));
      return ;
    }else {
      this.router.navigate(['/home']);
      return ;
    }
    
  //   if (!code || !sessionState){
  //       console.log('OIDC parameters not found');
  //       this.router.navigate(['/home/acm']);
  //       return ;
  // }
  //   else {
    
  //   return this.auth.oidcToken({
  //     code,
  //     state: sessionState
  //   }).pipe(
  //     map(response => {

  //       if (!response?.oidcToken) {
  //         return this.router.createUrlTree(['/home/acm']);
  //       }

  //       const { oidcToken, oidcUserBean } = response;

  //       sessionStorage.setItem(
  //         'oidcToken',
  //         atob(oidcToken)
  //       );

  //       sessionStorage.setItem(
  //         'username',
  //         oidcUserBean.userId
  //       );

  //       sessionStorage.setItem(
  //         'userId',
  //         oidcUserBean.userId
  //       );

  //       sessionStorage.setItem(
  //         'email',
  //         oidcUserBean.email
  //       );

  //       console.log('OIDC authentication successful');

  //       return true;
  //     }),
  //     catchError(error => {
  //       console.error('OIDC authentication failed', error);
  //       return of(
  //         this.router.createUrlTree(['/home/acm'])
  //       );
  //     })
  //   );
  //   }
  }
}
